const router = {}

// 篮球-杯赛-赛程
const FootballCupScheduleIndex = () =>
  import(
    /* webpackChunkName: "footballCupScheduleIndex" */ '@platfrom/football/cup_schedule/index.vue'
  )

// 篮球-杯赛-赛程详情
const BasketballLeagueScheduleDetailIndex = () =>
  import(
    /* webpackChunkName: "basketballLeagueScheduleDetailIndex" */ '@platfrom/basketball/league_scheduleDetail/index.vue'
  )

const BasketballCupScheduleDetailStartList = () =>
  import(
    /* webpackChunkName: "basketballCupScheduleDetailStartList" */ '@platfrom/basketball/cup_scheduleDetail/childPage/startList.vue'
  )

const BasketballLeagueScheduleDetailPreMatch = () =>
  import(
    /* webpackChunkName: "basketballLeagueScheduleDetailPreMatch" */ '@platfrom/basketball/league_scheduleDetail/childPage/preMatch.vue'
  )

const BasketballLeagueScheduleDetailHotspots = () =>
  import(
    /* webpackChunkName: "basketballLeagueScheduleDetailLineup" */ '@platfrom/basketball/league_scheduleDetail/childPage/hotspots.vue'
  )

const BasketballLeagueScheduleDetailAnalysis = () =>
  import(
    /* webpackChunkName: "basketballLeagueScheduleDetailAnalysis" */ '@platfrom/basketball/league_scheduleDetail/childPage/analysis.vue'
  )

const BasketballLeagueScheduleDetailStatistics = () =>
  import(
    /* webpackChunkName: "basketballLeagueScheduleDetailStatistics" */ '@platfrom/basketball/league_scheduleDetail/childPage/statistics.vue'
  )

// 篮球-杯赛-球队
const FootballCupTeamIndex = () =>
  import(
    /* webpackChunkName: "footballCupTeamListIndex" */ '@platfrom/football/cup_team/index.vue'
  )

// 篮球-杯赛-球队详情
// const FootballCupTeamDetailIndex = () =>
//   import(
//     /* webpackChunkName: "footballCupTeamDetailIndex" */ '@platfrom/football/cup_teamDetail/index.vue'
//   )
// const FootballCupTeamDetailTeamData = () =>
//   import(
//     /* webpackChunkName: "footballCupTeamDetailTeamData" */ '@platfrom/football/cup_teamDetail/childPage/teamData.vue'
//   )

// const FootballCupTeamDetailPlayerList = () =>
//   import(
//     /* webpackChunkName: "footballCupTeamDetailPlayerList" */ '@platfrom/football/cup_teamDetail/childPage/playerList.vue'
//   )

// const FootballCupTeamDetailMatchRecord = () =>
//   import(
//     /* webpackChunkName: "footballCupTeamDetailMatchRecord" */ '@platfrom/football/cup_teamDetail/childPage/matchRecord.vue'
//   )

// 篮球-杯赛-积分榜
const FootballCupLeagueTableIndex = () =>
  import(
    /* webpackChunkName: "footballCupLeagueTableIndex" */ '@platfrom/football/cup_leagueTable/index.vue'
  )

// 篮球-杯赛-淘汰赛
const FootballCupKnockoutRoundsIndex = () =>
  import(
    /* webpackChunkName: "footballCupKnockoutRoundsIndex" */ '@platfrom/football/cup_knockoutRounds/index.vue'
  )

// 篮球-联赛-数据
const BasketballLeagueRecordDetailIndex = () =>
  import(
    /* webpackChunkName: "basketballLeagueRecordDetailIndex" */ '@platfrom/basketball/league_record/index.vue'
  )

// 篮球-联赛-数据-数据概览
const BasketballLeagueRecordDetailDataOverview = () =>
  import(
    /* webpackChunkName: "basketballLeagueRecordDetailDataOverview" */ '@platfrom/basketball/league_record/childPage/dataOverview.vue'
  )
// 篮球-联赛-数据-球队数据
const BasketballLeagueRecordDetailTeamData = () =>
  import(
    /* webpackChunkName: "basketballLeagueRecordDetailTeamData" */ '@platfrom/basketball/league_record/childPage/teamData.vue'
  )
// 篮球-联赛-数据-球员数据
const BasketballLeagueRecordDetailPlayerData = () =>
  import(
    /* webpackChunkName: "basketballLeagueRecordDetailPlayerData" */ '@platfrom/basketball/league_record/childPage/playerData.vue'
  )

// 篮球-联赛-数据-阵容数据
const BasketballLeagueRecordDetailLineupData = () =>
  import(
    /* webpackChunkName: "basketballLeagueRecordDetailLineupData" */ '@platfrom/basketball/league_record/childPage/lineupData.vue'
  )

// 篮球-杯赛-球员
const FootballCupPlayerIndex = () =>
  import(
    /* webpackChunkName: "footballCupPlayerIndex" */ '@platfrom/basketball/league_player/index.vue'
  )
// 篮球-杯赛-球员详情
// const FootballCupPlayerDetailIndex = () =>
//   import(
//     /* webpackChunkName: "footballCupPlayerDetailIndex" */ '@platfrom/football/cup_playerDetail/index.vue'
//   )

// 篮球-杯赛-场馆
// const FootballCupSportsHallIndex = () =>
//   import(
//     /* webpackChunkName: "footballCupSportsHallIndex" */ '@platfrom/football/cup_sportsHall/index.vue'
//   )

// 篮球-杯赛-播出单
const FootballCupBroadcastListIndex = () =>
  import(
    /* webpackChunkName: "commonPageBroadcastListIndex" */ '@platfrom/commonPage/broadcastList/index.vue'
  )

// 篮球-杯赛-数据包装
const FootballCupDataPackagListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageDataPackagListIndex" */ '@platfrom/commonPage/dataPackagList/index.vue'
  )

// 马拉松-节目单
const FootballCupProgramListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageProgramListIndex" */ '@platfrom/commonPage/programList/index.vue'
  )

// 篮球-杯赛-H5组件
const FootballCupH5CompIndex = () =>
  import(
    /* webpackChunkName: "footballCupH5CompIndex" */ '@platfrom/football/cup_h5Comp/index.vue'
  )

router.FootballCupScheduleIndex = FootballCupScheduleIndex
router.BasketballLeagueScheduleDetailIndex = BasketballLeagueScheduleDetailIndex
// router.FootballCupScheduleDetailPreMatch = FootballCupScheduleDetailPreMatch
// router.FootballCupScheduleDetailLineup = FootballCupScheduleDetailLineup
// router.FootballCupScheduleDetailAnalysis = FootballCupScheduleDetailAnalysis
// router.FootballCupScheduleDetailStatistics = FootballCupScheduleDetailStatistics
router.BasketballCupScheduleDetailStartList =
  BasketballCupScheduleDetailStartList
router.BasketballLeagueScheduleDetailPreMatch =
  BasketballLeagueScheduleDetailPreMatch
router.BasketballLeagueScheduleDetailHotspots =
  BasketballLeagueScheduleDetailHotspots
router.BasketballLeagueScheduleDetailAnalysis =
  BasketballLeagueScheduleDetailAnalysis
router.BasketballLeagueScheduleDetailStatistics =
  BasketballLeagueScheduleDetailStatistics
router.FootballCupTeamIndex = FootballCupTeamIndex
// router.FootballCupTeamDetailIndex = FootballCupTeamDetailIndex
// router.FootballCupTeamDetailTeamData = FootballCupTeamDetailTeamData
// router.FootballCupTeamDetailPlayerList = FootballCupTeamDetailPlayerList
// router.FootballCupTeamDetailMatchRecord = FootballCupTeamDetailMatchRecord
router.FootballCupLeagueTableIndex = FootballCupLeagueTableIndex
router.FootballCupKnockoutRoundsIndex = FootballCupKnockoutRoundsIndex
router.BasketballLeagueRecordDetailIndex = BasketballLeagueRecordDetailIndex
router.BasketballLeagueRecordDetailDataOverview =
  BasketballLeagueRecordDetailDataOverview
router.BasketballLeagueRecordDetailTeamData =
  BasketballLeagueRecordDetailTeamData
router.BasketballLeagueRecordDetailPlayerData =
  BasketballLeagueRecordDetailPlayerData
router.BasketballLeagueRecordDetailLineupData =
  BasketballLeagueRecordDetailLineupData
router.FootballCupPlayerIndex = FootballCupPlayerIndex
// router.FootballCupPlayerDetailIndex = FootballCupPlayerDetailIndex
// router.FootballCupSportsHallIndex = FootballCupSportsHallIndex
router.FootballCupBroadcastListIndex = FootballCupBroadcastListIndex
router.FootballCupProgramListIndex = FootballCupProgramListIndex
router.FootballCupH5CompIndex = FootballCupH5CompIndex
router.FootballCupDataPackagListIndex = FootballCupDataPackagListIndex

export default router
